/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);h4[_ngcontent-%COMP%]{color:#013d52;font-size:1.5rem;font-weight:600;padding-bottom:15px;border-bottom:1px solid #d7dae3}.info[_ngcontent-%COMP%]{color:#013d52;margin-top:30px}.feed[_ngcontent-%COMP%]{color:red}.feed[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:15px}"];
export { styles as styles };
